
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'
import {CURRENT_USER, CURRENT_USER_EDIT_PROFILE, SIGNUP, LOGOUT} from '../currentUser'

export const USER_ADD = loadTypes('USER_ADD')
export const USERS = loadTypes('USERS')

function processUsers(request, response) {
  if (!response || !response.length) return {}

  return response.reduce((acc, item) => {
    acc[item.id] = item
    return acc
  }, {})
}

export default function users(state = {}, action) {
  switch (action.type) {
    case CURRENT_USER.SUCCESS:
    case SIGNUP.SUCCESS:
      return {
        ...state,
        [action.response.id]: action.response
      }

    case LOGOUT.SUCCESS:
      return {}

    case CURRENT_USER_EDIT_PROFILE.SUCCESS:
      return {
        ...state,
        [action.response.id]: action.response
      }

    case USERS.SUCCESS:
      return {
        ...state,
        ...processUsers(action.request, action.response)
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/users/index.js